import { EmptyComponent } from "../utils/EmptyComponent";
import { AppSwitch } from "./AppSwitch";

export const serviceAppSwitch = ({ getConfig }) => {
  const appSwitch = getConfig("one.layout.appSwitch", true);

  return [
    {
      target: "$ONE_TOOLBAR_CONTENT_RIGHT",
      handler: { component: appSwitch ? AppSwitch : EmptyComponent }
    }
  ];
};
